/* JungleSocks · Animación «Configura tu pack» (DS Performance)
   Llena los huecos uno a uno, mueve la barra y sube el descuento por escalones. */
(function () {
  if (window.__pbaBoot) return;
  window.__pbaBoot = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP = 900, HOLD = 2800, RESET = 700;

  function init(root) {
    if (root.__pba) return;
    root.__pba = true;
    var max = parseInt(root.dataset.max, 10) || 6;
    var tiers = (root.dataset.tiers || '').split(',').map(function (t) {
      var p = t.split(':');
      return { n: parseInt(p[0], 10), pct: parseInt(p[1], 10) };
    }).filter(function (t) { return t.n && t.pct; }).sort(function (a, b) { return a.n - b.n; });
    var slots = root.querySelectorAll('[data-pba-slot]');
    var marks = root.querySelectorAll('[data-pba-mark]');
    var nEl = root.querySelector('[data-pba-n]');
    var fill = root.querySelector('[data-pba-fill]');
    var pctEl = root.querySelector('[data-pba-pct]');
    var noteEl = root.querySelector('[data-pba-note]');
    var n = 0, lastPct = 0, timer = null, visible = false;

    function render(isNew) {
      for (var i = 0; i < slots.length; i++) {
        slots[i].classList.toggle('is-filled', i < n);
        slots[i].classList.toggle('is-new', !!isNew && i === n - 1);
      }
      nEl.textContent = n;
      fill.style.width = (n / max * 100) + '%';
      var pct = 0;
      tiers.forEach(function (t) { if (n >= t.n) pct = t.pct; });
      for (var j = 0; j < marks.length; j++) {
        marks[j].classList.toggle('is-on', n >= parseInt(marks[j].getAttribute('data-pba-mark'), 10));
      }
      pctEl.textContent = pct ? '\u2212' + pct + '\u00a0%' : '\u2014';
      noteEl.textContent = pct ? root.dataset.auto : root.dataset.from;
      root.classList.toggle('is-deal', pct > 0);
      if (pct && pct !== lastPct && !reduce) {
        pctEl.classList.remove('is-bump');
        void pctEl.offsetWidth;
        pctEl.classList.add('is-bump');
      }
      lastPct = pct;
    }

    function step() {
      if (n < max) {
        n++;
        render(true);
        timer = setTimeout(step, n === max ? HOLD : STEP);
      } else {
        n = 0;
        render(false);
        timer = setTimeout(step, RESET);
      }
    }
    function start() { if (!timer) timer = setTimeout(step, 500); }
    function stop() { clearTimeout(timer); timer = null; }

    if (reduce) { n = max; render(false); return; }
    render(false);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible && !document.hidden) start(); else stop();
        });
      }, { threshold: 0.25 }).observe(root);
    } else {
      visible = true;
      start();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else if (visible) start();
    });
  }

  function boot() { document.querySelectorAll('[data-pba]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
